export default __webpack_public_path__ + "static/media/Bhedaghat-marble-rocks-jabalpur.e0b81974.jpg";